module.exports = __webpack_public_path__ + "img/virtual_kit.3cea1ccf.png";